import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Button,
} from "reactstrap";
import SimpleLineChart from "../AllCharts/rechart/SimpleLineChart";
import SimpleAreaChart from "../AllCharts/rechart/SimpleAreaChart";
import MixBarChart from "../AllCharts/rechart/MixBarChart";
import VerticalComposedChart from "../AllCharts/rechart/VerticalComposedChart";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import axios from "axios";

const Performance = () => {

  const authToken = localStorage.getItem("access");
  // const authToken = JSON.parse(localStorage.getItem("authUser")).token;
  const [machines, setMachines] = useState([]);

  const [oeeData, setOeeData] = useState([]);
  const [teepData, setTeepData] = useState([]);
  const [goodProductData, setGoodProductData] = useState([]);
  const [updateChartData, setUpdateChartData] = useState([]);
  const [timestamps, setTimestamps] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
   const selectedMachineId = localStorage.getItem('selectedMachineId');
     const [selectedMachine, setSelectedMachine] = useState(selectedMachineId);
  useEffect(() => {
    fetchMachines();
  }, []);
  const [parts1DataMap, setParts1DataMap] = useState({
    goodPartsList: [],
    badPartsList: [],
    totalPartsList: [],
    dateTimeList: [],
    oeeeList: [],
    teepList: [],
    scraprateList: [],
    capacityUtilizationList: [],
  });

  const [parts2DataMap, setParts2DataMap] = useState({
    goodPartsList: [],
    badPartsList: [],
    totalPartsList: [],
    dateTimeList: [],
    oeeeList: [],
    teepList: [],
    scraprateList: [],
    capacityUtilizationList: [],
  });

  const [parts3DataMap, setParts3DataMap] = useState({
    goodPartsList: [],
    badPartsList: [],
    totalPartsList: [],
    dateTimeList: [],
    oeeeList: [],
    teepList: [],
    scraprateList: [],
    capacityUtilizationList: [],
  });

  const [dateMap, setDateMap] = useState({
    dateTimeList: [],
  });

  const [allData, setAllData] = useState([]);

  const downloadExcel = async () => {
    try {
      // Fetch the data from your API
      const response = await fetch(
        "http://ec2-35-154-129-107.ap-south-1.compute.amazonaws.com:3003/api/data/performance",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`, // Include your authentication token if needed
          },
        }
      );
      console.log(response);
      // Check if the response is successful
      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "shift_metrics.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else if (response.status === 401) {
        // Unauthorized: Handle authentication error
        console.error("Authentication error");
      } else {
        // Handle other errors
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchMachines = async () => {
    try {
      
      const response = await fetch("https://api.hanoch.in/api/machines",
        // {
        //   headers: {
        //     "Content-Type": "application/json",
        //     Authorization: `Bearer ${authToken}`,
        //   },
        // }
      );

      if (response.ok) {
        const machines = await response.json();
        setMachines(machines.data);
        setSelectedMachine(machines.data[33].id)

      } else if (response.status === 401) {
        // Unauthorized: Log out the user
        localStorage.removeItem("access");
        // localStorage.removeItem("admin");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }finally {
      
    }
  };

  const [selectedDate, setSelectedDate] = useState(() => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    // console.log( `${year}-${month}-${day}`,'yyyyyyy');
    return `${year}-${month}-${day}`;
  });
  const isShiftDisabled = (shift) => {
    const now = new Date();
    const currentHour = now.getHours();

    if (shift === "1") {
      return currentHour < 6; // After 2 PM, Shift 1 is over
    } else if (shift === "2") {
      return currentHour < 14; // After 10 PM, Shift 2 is over
    } else if (shift === "3") {
      return currentHour < 22 && currentHour >= 6;
      // Shift 3 (10PM-6AM) is *upcoming* if it's between 6 AM to 10 PM
    }
    return false;
  };
  const getCurrentShift = () => {
    const now = new Date();
    const hours = now.getHours();

    if (hours >= 6 && hours < 14) {
      return 1; // Shift 1: 6am to 2pm
    } else if (hours >= 14 && hours < 22) {
      return 2; // Shift 2: 2pm to 10pm
    } else {
      return 3; // Shift 3: 10pm to 6am
    }
  };
  const [selectedShift, setSelectedShift] = useState(getCurrentShift());


  const fetchPerformance = async () => {
    if (selectedDate && selectedMachine && selectedShift)
      try {
setIsLoading(true);
        // Fetch data from your API
        const response = await fetch(
          `https://api.hanoch.in/production-film/oee_teep_graph/?shift=${selectedShift}&date=${selectedDate}&machine_id=${selectedMachine}`,
          {
            headers: {
              "Content-Type": "application/json",
              // Authorization: `Bearer ${authToken}`, // Replace with your actual token
            },
          }
        );

        if (response.ok) {
          const data = await response.json();
          console.log("performance", data)
          setAllData(data?.data || []);
          const transformedData = {
            oeeList: data.data.map((item) => item.oee),
            teepList: data.data.map((item) => item.teep),
            dateTimeList: data.data.map((item) => item.time),
          };

          setUpdateChartData(transformedData);


        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {

    if (selectedMachine && selectedDate && selectedShift) {
      fetchPerformance();
    }
  }, [selectedDate, selectedMachine, selectedShift]);

  useEffect(() => {
  const isToday = selectedDate === new Date().toISOString().split('T')[0];

  let intervalId;

  if (isToday && selectedMachine && selectedShift) {
    intervalId = setInterval(() => {
      fetchPerformance();
    }, 60000); // 60,000 ms = 1 minute
  }

  // Cleanup to clear interval on unmount or dependency change
  return () => {
    if (intervalId) clearInterval(intervalId);
  };
}, [selectedDate, selectedMachine, selectedShift]);

  const handleMachineChange = async (event) => {
    const newMachine = event.target.value;
    setSelectedMachine(newMachine);
 localStorage.setItem('selectedMachineId', newMachine);

  };

  const handleShiftChange = (event) => {
    const newShift = event.target.value;
    setSelectedShift(newShift);
  };


  const handleDateChange = (event) => {
    const newDate = event.target.value;
    setSelectedDate(newDate);
  };
 
  document.title = "Performance ";
  return (
    <React.Fragment>
      
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="OptiMize" breadcrumbItem="Performance" />
          <div >
            <label>Select Machine</label>
            <select
              id="machine"
              // name="selectedMachine"
              value={selectedMachine}
              onChange={handleMachineChange}
              style={{ padding: "3px", margin: "10px", borderRadius: "10px" }}>
              <option value="">Select a machine</option>
              {machines?.map((machine) => (
                <option key={machine.id} value={machine.id}>
                  {machine.name}
                </option>
              ))}
            </select>
            <label>shift</label>
            <select
              value={selectedShift}
              onChange={handleShiftChange}
              style={{ padding: "3px", margin: "10px", borderRadius: "10px" }}>
              <option value="">Select a shift</option>
              <option value="1" disabled={selectedDate === new Date().toISOString().split('T')[0] && isShiftDisabled("1")} >6-2 (Shift 1)</option>
              <option value="2" disabled={selectedDate === new Date().toISOString().split('T')[0] && isShiftDisabled("2")}>2-10 (Shift 2)</option>
              <option value="3" disabled={selectedDate === new Date().toISOString().split('T')[0] && isShiftDisabled("3")}>10-6 (Shift 3)</option>
            </select>



            <label>date</label>



            <input
              type="date"
              value={selectedDate}
              onChange={handleDateChange}
              max={new Date().toISOString().split('T')[0]}
              style={{ padding: "3px", margin: "10px", borderRadius: "10px" }}


            // style={{
            //   padding: "4px 8px",
            //   backgroundColor: "#21262d",
            //   color: "#c9d1d9",

            //   border: "1px solid #30363d",
            //   borderRadius: "6px",
            //   fontSize: "13px"
            // }}
            />
          </div>


          {/* <Button onClick={handleDownloadClick} disabled={isDownloading}>
                        {isDownloading ? 'Downloading...' : 'Download Report'}
                    </Button> */}
          <div>
            {isLoading ? (
            <div className="text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <Row>
            <Col xl={6}>
              <Card>
                <CardHeader className="mb-4">
                  OVER ALL EQUIPMENT EFFICIENCY (OEE)
                </CardHeader>
                <CardBody>
                  <SimpleLineChart
                    partsDataMap={updateChartData}

                    dateMap={updateChartData}
                  />
                </CardBody>
              </Card>
            </Col>
            
            {/* <Col xl={6}>
              <Card>
                <CardHeader className="mb-4">
                  TOTAL EQUIPMENT EFFECTIVE PERFORMANCE (TEEP)
                </CardHeader>
                <CardBody>
                  <SimpleAreaChart
                    partsDataMap={updateChartData}

                    dateMap={updateChartData}
                  />
                </CardBody>
              </Card>
            </Col> */}
            </Row>
          )}
          </div>
           <div>
             {isLoading ? (
            <div className="text-center">
              <div className="" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
          
               <Row>
            <Col xl={6}>
              <Card>
                <CardHeader className="mb-4">SCRAP RATE</CardHeader>
                <CardBody>
                  <MixBarChart
                    parts1DataMap={parts1DataMap}
                    parts2DataMap={parts2DataMap}
                    parts3DataMap={parts3DataMap}
                    dateMap={dateMap}
                  />
                </CardBody>
              </Card>
            </Col>
            <Col xl={6}>
              <Card>
                <CardHeader className="mb-4">CAPACITY UTILIZATION</CardHeader>
                <CardBody>
                  <VerticalComposedChart
                    parts1DataMap={parts1DataMap}
                    parts2DataMap={parts2DataMap}
                    parts3DataMap={parts3DataMap}
                    dateMap={dateMap}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          )}
          </div>

          {/* <Row> */}
          {/* Order Stats */}
          {/* <OrderStatus /> */}
          {/* Notifications */}
          {/* <Notifications /> */}
          {/* Revenue by Location Vector Map */}
          {/* <RevenueByLocation /> */}
          {/* </Row> */}

          {/* Latest Transaction Table */}
          {/* <LatestTransation /> */}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Performance;
